import Dimensions from "../Dimensions";

var PixelRatio = function () {
  function PixelRatio() {}

  PixelRatio.get = function get() {
    return Dimensions.get('window').scale;
  };

  PixelRatio.getFontScale = function getFontScale() {
    return Dimensions.get('window').fontScale || PixelRatio.get();
  };

  PixelRatio.getPixelSizeForLayoutSize = function getPixelSizeForLayoutSize(layoutSize) {
    return Math.round(layoutSize * PixelRatio.get());
  };

  PixelRatio.roundToNearestPixel = function roundToNearestPixel(layoutSize) {
    var ratio = PixelRatio.get();
    return Math.round(layoutSize * ratio) / ratio;
  };

  return PixelRatio;
}();

export { PixelRatio as default };